import React from 'react';
import LoadingBar from 'react-redux-loading-bar';

function Loading() {
  const loadingBarStyle = {
    backgroundColor: '#3B6E03',
    height: '3px',
  };

  return (
    <div className="loading">
      <LoadingBar style={loadingBarStyle} />
    </div>
  );
}

export default Loading;
